module.exports = __webpack_public_path__ + "static/media/Nile Buisness Tower Still 04.d1a0fdf2.webp";